<template>
  <device-wrapper #default="{ desktop }">
    <desktop-product-page v-if="desktop"/>
    <mobile-product-page v-else/>
  </device-wrapper>
</template>

<script setup>
import MobileProductPage from "@/components/product/mobile/index";
import DesktopProductPage from "@/components/product/desktop/index";
import {useCategoryStore} from "@/store/category";

const categoryStore = useCategoryStore()
const {openPageFrom} = storeToRefs(categoryStore)

onUnmounted(() => {
  openPageFrom.value = 'product'
})
</script>
